/* ===================================================================
   THE FLOAT CLUB — fc-translate.js
   Language picker, same mechanism as the Costa Global Capital site:
   a globe + 2-letter pill that drives Google's translate engine in
   place. There is no hand-translated copy for this site, so what the
   visitor gets is machine translation and the panel says so — do not
   remove that line and present it as a professional localisation.

   Styling mirrors CGC's .cgc-lang-picker: pill trigger, chevron that
   rotates on open, right-aligned drop panel on desktop, bottom sheet
   under 768px.
=================================================================== */
(function (global) {
  "use strict";

  var LANGS = [
    { code: "en",    label: "English",  short: "EN" },
    { code: "de",    label: "Deutsch",  short: "DE" },
    { code: "fr",    label: "Français", short: "FR" },
    { code: "es",    label: "Español",  short: "ES" },
    { code: "it",    label: "Italiano", short: "IT" },
    { code: "nl",    label: "Nederlands", short: "NL" },
    { code: "pt",    label: "Português", short: "PT" },
    { code: "ja",    label: "日本語",    short: "JA" }
  ];

  var GLOBE = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle>' +
    '<path d="M3 12h18"></path><path d="M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18"></path></svg>';

  var current = "en";
  try { current = localStorage.getItem("fc_lang") || "en"; } catch (e) {}

  function labelFor(code) {
    for (var i = 0; i < LANGS.length; i++) if (LANGS[i].code === code) return LANGS[i].short;
    return "EN";
  }

  function injectStyles() {
    var css = document.createElement("style");
    css.textContent = [
      ".fc-lang{position:relative}",
      ".fc-lang-trigger{display:inline-flex;align-items:center;gap:8px;height:46px;padding:0 14px;",
      "border-radius:14px;cursor:pointer;background:rgba(3,24,31,0.38);backdrop-filter:blur(8px);",
      "border:1px solid rgba(255,255,255,0.14);color:#EAF6F8;font-family:Anton,sans-serif;",
      "font-size:12px;letter-spacing:0.1em;transition:background .2s ease,border-color .2s ease}",
      ".fc-lang-trigger:hover{background:rgba(255,255,255,0.12);border-color:rgba(255,255,255,0.25)}",
      ".fc-lang-chev{transition:transform .22s ease}",
      ".fc-lang.open .fc-lang-chev{transform:rotate(180deg)}",
      ".fc-lang-menu{display:none;position:absolute;right:0;top:calc(100% + 8px);min-width:250px;",
      "padding:8px;border-radius:16px;background:#FFFFFF;",
      "border:1px solid rgba(5,34,43,0.16);box-shadow:0 24px 48px rgba(3,24,31,0.22);z-index:60;",
      "grid-template-columns:1fr 1fr;gap:2px}",
      ".fc-lang.open .fc-lang-menu{display:grid}",
      ".fc-lang-item{padding:10px 12px;border-radius:10px;border:none;cursor:pointer;background:transparent;",
      "color:#05222B;font-family:Archivo,sans-serif;font-weight:500;font-size:12px;text-align:left;",
      "letter-spacing:0.06em;transition:background .18s ease,color .18s ease}",
      ".fc-lang-item:hover{background:rgba(5,34,43,0.06);color:#05222B}",
      ".fc-lang-item.is-active{background:rgba(255,197,61,0.22);color:#7A5200}",
      ".fc-lang-item.is-active::after{content:' \\2713'}",
      ".fc-lang-note{grid-column:1 / -1;margin:6px 10px 4px;font-size:9px;line-height:1.6;",
      "letter-spacing:0.06em;text-transform:uppercase;color:rgba(5,34,43,0.78)}",
      "#google_translate_element{display:none!important}",
      "body{top:0!important}.skiptranslate{display:none!important}",
      "#fc-mnav .fc-lang-trigger{background:#FFFFFF;border-color:rgba(5,34,43,0.2);color:#05222B;backdrop-filter:none;font-family:Archivo,sans-serif;font-weight:700}",
      "#fc-mnav .fc-lang-trigger:hover{background:rgba(5,34,43,0.05);border-color:rgba(5,34,43,0.35)}",
      "#fc-mnav .fc-lang-menu{position:absolute;left:0;right:auto;top:calc(100% + 8px);bottom:auto;border-radius:16px;padding:8px;box-shadow:0 24px 48px rgba(3,24,31,0.22)}",
      "@media(max-width:767px){.fc-lang-menu{position:fixed;left:0;right:0;bottom:0;top:auto;",
      "min-width:0;border-radius:20px 20px 0 0;padding:16px}}"
    ].join("");
    document.head.appendChild(css);
  }

  // built into every host, so the header (desktop) and the nav drawer
  // (mobile) each get their own picker
  function build() {
    document.querySelectorAll(".fc-lang-host").forEach(buildInto);
  }

  function buildInto(host) {
    var wrap = document.createElement("div");
    wrap.className = "fc-lang notranslate";

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "fc-lang-trigger";
    btn.setAttribute("aria-haspopup", "true");
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-label", "Choose language");
    btn.innerHTML = GLOBE + '<span class="fc-lang-code">' + labelFor(current) + '</span>' +
      '<svg class="fc-lang-chev" width="12" height="12" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2.6" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg>';

    var menu = document.createElement("div");
    menu.className = "fc-lang-menu";
    menu.setAttribute("role", "menu");

    LANGS.forEach(function (l) {
      var item = document.createElement("button");
      item.type = "button";
      item.setAttribute("role", "menuitem");
      item.className = "fc-lang-item" + (l.code === current ? " is-active" : "");
      item.setAttribute("data-lang", l.code);
      item.textContent = l.label;
      item.addEventListener("click", function (e) {
        e.stopPropagation();
        switchTo(l.code);
        wrap.classList.remove("open");
        btn.setAttribute("aria-expanded", "false");
      });
      menu.appendChild(item);
    });

    var note = document.createElement("p");
    note.className = "fc-lang-note";
    note.textContent = "Machine translation. English is the original.";
    menu.appendChild(note);

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = wrap.classList.toggle("open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("click", function () {
      wrap.classList.remove("open");
      btn.setAttribute("aria-expanded", "false");
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        wrap.classList.remove("open");
        btn.setAttribute("aria-expanded", "false");
      }
    });

    wrap.appendChild(btn);
    wrap.appendChild(menu);
    host.appendChild(wrap);
  }

  function switchTo(code) {
    var wasTranslated = current !== "en";
    current = code;
    try { localStorage.setItem("fc_lang", code); } catch (e) {}

    document.querySelectorAll(".fc-lang-code").forEach(function (n) {
      n.textContent = labelFor(code);
    });
    document.querySelectorAll(".fc-lang-item").forEach(function (n) {
      n.classList.toggle("is-active", n.getAttribute("data-lang") === code);
    });

    // Google's widget reads this cookie on load and its hidden <select>
    // drives in-place translation without a reload once it exists.
    var val = (code === "en") ? "/en/en" : "/en/" + code;
    document.cookie = "googtrans=" + val + ";path=/";
    document.cookie = "googtrans=" + val + ";path=/;domain=." + location.hostname;

    // Returning to English is not just another language swap: setting the
    // combo back to "" and dispatching change asks Google's widget to
    // revert the DOM, but the widget does not reliably restore every node
    // it rewrote (this is the bug — a FR -> EN switch left the page in
    // French until a manual reload). Rather than ship a half-translated
    // page, a return to the site's original language always reloads once
    // anything has actually been translated. The cookie above is already
    // set to /en/en, so the reload lands back in clean, original English,
    // never a stale mix.
    if (code === "en") {
      if (wasTranslated) location.reload();
      return;
    }

    var combo = document.querySelector(".goog-te-combo");
    if (combo) {
      combo.value = code;
      combo.dispatchEvent(new Event("change"));
    } else {
      location.reload();
    }
  }

  /* -----------------------------------------------------------------
     MEASUREMENT GUARD — Google's widget translates every text node it
     can see, including the sizing table, which mistranslates units
     ("in" reads as a preposition and becomes "dans") and only partially
     converts weights. This site has no unit-conversion logic and is not
     going to fake one, so the fix is to keep the sizing table's numbers
     out of translation entirely: wrap matching text nodes in a
     class="notranslate" span before the engine ever loads. Google's
     Website Translator honours notranslate and skips those nodes.
  --------------------------------------------------------------------- */
  var MEASUREMENT_RE = /\d[\d–\-\s]*\s*(in|lb)\b/i;

  function guardMeasurements() {
    var hosts = document.querySelectorAll("#sizes, .fc-rte");
    hosts.forEach(function (host) {
      var walker = document.createTreeWalker(host, NodeFilter.SHOW_TEXT, null, false);
      var toWrap = [];
      var node;
      while ((node = walker.nextNode())) {
        var text = node.nodeValue;
        if (text && text.trim() && MEASUREMENT_RE.test(text)) toWrap.push(node);
      }
      toWrap.forEach(function (n) {
        var span = document.createElement("span");
        span.className = "notranslate";
        span.textContent = n.nodeValue;
        if (n.parentNode) n.parentNode.replaceChild(span, n);
      });
    });
  }

  function loadEngine() {
    if (document.getElementById("fc-gt-script")) return;

    var host = document.createElement("div");
    host.id = "google_translate_element";
    document.body.appendChild(host);

    global.fcTranslateInit = function () {
      /* global google */
      new google.translate.TranslateElement({
        pageLanguage: "en",
        includedLanguages: LANGS.map(function (l) { return l.code; }).join(","),
        autoDisplay: false
      }, "google_translate_element");
    };

    var s = document.createElement("script");
    s.id = "fc-gt-script";
    s.src = "https://translate.google.com/translate_a/element.js?cb=fcTranslateInit";
    s.async = true;
    document.body.appendChild(s);
  }

  function init() {
    injectStyles();
    build();
    guardMeasurements();
    if (current !== "en") loadEngine();
    else {
      // load lazily on first interaction so English visitors pay nothing
      var once = function () {
        loadEngine();
        document.removeEventListener("pointerdown", once);
      };
      document.addEventListener("pointerdown", once, { once: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  global.FC_LANG = { switchTo: switchTo, languages: LANGS };

})(window);
